import React, { useState, useRef, useEffect } from 'react'

import styles from './Marquee.module.less'
import Icon from '@/components/Icon/Icon'

interface MarqueeProps {
  text: string
  speed?: number
}

const Marquee: React.FC<MarqueeProps> = ({ text = '', speed = 20 }) => {
  const [show, setShow] = useState(false) // 是否显示组件
  const [showAnimation, setShowAnimation] = useState(false) // 是否显示跑马灯动画
  const [textWidth, setTextWidth] = useState(0)
  const [constainerWidth, setContainerWidth] = useState(0)
  const [animationDuration, setAnimationDuration] = useState('0s')
  const [animationDelay, setAnimationDelay] = useState('0s')
  const marqueeTextContainer = useRef<HTMLDivElement>(null)
  const marqueeTextClone = useRef<HTMLDivElement>(null)

  const translateStyle = {
    // transform: `translateX(${constainerWidth}px)`, // constainerWidth + 'px',
    // animationDuration: animationDuration,
    // animationDelay: animationDelay
  }

  const textStyle = {
    animation: `${animationDuration} linear forwards ${styles['move-one']}, ${animationDuration} linear infinite ${animationDelay} ${styles['move-two']}`,
  }

  useEffect(() => {
    if (marqueeTextContainer.current && marqueeTextClone.current) {
      setContainerWidth(marqueeTextContainer.current.offsetWidth)
      setTextWidth(marqueeTextClone.current.offsetWidth)
      const totalWidth = constainerWidth + textWidth
      setAnimationDuration(`${(totalWidth / speed).toFixed(2)}s`)
      setAnimationDelay(`-${(textWidth / speed).toFixed(2)}s`)
      setShowAnimation(textWidth > constainerWidth)
      setShow(true)
    }
  }, [constainerWidth, textWidth, text, speed, show, showAnimation])

  return (
    <>
      <div
        className={styles['marquee-container']}
        style={{ ...translateStyle }}
      >
        <div className={styles['marquee']}>
          <Icon
            className={styles['marquee-icon']}
            name="notice"
            color="#fe5700"
            size="40"
          ></Icon>

          <div
            className={styles['marquee-text-container']}
            ref={marqueeTextContainer}
          >
            {show && !showAnimation ? (
              <div className={styles['marquee-text']}>{text}</div>
            ) : (
              <div className={styles['marquee-text']} style={{ width: textWidth + 'px', ...textStyle }}>
                {text}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* <!-- 隐藏，用于获取文字实际宽度 --> */}
      <div
        className={styles['marquee-text'] + ' ' + styles['marquee-text-clone']}
        ref={marqueeTextClone}
      >
        {text}
      </div>
    </>
  )
}

export default Marquee
